export const formatCurrencyINR = (
	amount: number,
	minimumFractionDigits = 2,
	rounding?: 'floor' | 'ceil' | 'round' | 'none',
	options?: any
) => {
	if (amount === undefined || amount === null) return '';

	let roundedAmount = amount;

	if (rounding === 'floor') {
		roundedAmount = Math.floor(amount);
	} else if (rounding === 'ceil') {
		roundedAmount = Math.ceil(amount);
	} else if (rounding === 'round') {
		roundedAmount = Math.round(amount);
	} else {
		roundedAmount = amount;
	}

	return new Intl.NumberFormat('en-IN', {
		style: 'currency',
		minimumFractionDigits,
		useGrouping: true,
		currency: 'INR',
		compactDisplay: 'long',
		...(options || {})
	}).format(roundedAmount);
};
